import { IProductToCategory } from "@evennt-tech/api-v2-core";
import { OrderProductSubCategories } from "ts/api/order";

const getProductSubCategory = (
  categories: IProductToCategory[]
): OrderProductSubCategories => {
  const subCategories = categories?.length
    ? categories.reduce<OrderProductSubCategories>((acc, category) => {
        const mainCategoryName = category.mainCategory?.name;
        const subCategoryName = category.subCategory?.name;

        if (!mainCategoryName) {
          return acc;
        }

        const subCategoryNames = acc[mainCategoryName]?.subCategoryNames ?? [];

        acc[mainCategoryName] = {
          subCategoryNames: subCategoryName
            ? [...subCategoryNames, subCategoryName]
            : subCategoryNames,
        };

        return acc;
      }, {})
    : {};

  return subCategories;
};

export default getProductSubCategory;
